import styled, { keyframes } from 'styled-components';

const borderPulse = keyframes`
   0%   { border-color: var(--partial-border-color); }
   50%  { border-color: transparent; }
   100% { border-color: var(--partial-border-color); }
`;

export const StyledPartialPreviewBox = styled.div`
   --partial-border-color: ${(props) => props.theme.error};

   min-height: 48px;
   padding: 12px;
   border: 2px solid var(--partial-border-color);
   border-radius: 8px;
   background-color: ${(props) => props.theme.backgroundBody};
   font-size: 13px;
   font-style: italic;
   color: ${(props) => props.theme.secondary};
   line-height: 1.5;
   white-space: pre-wrap;

   /*
    * Animate only border-color — will-change isolates the element on its own
    * compositing layer so text/background don't repaint on every frame.
    */
   animation: ${borderPulse} 1.5s ease-in-out infinite;
   will-change: border-color;
`;

StyledPartialPreviewBox.displayName = 'StyledPartialPreviewBox';
